<script setup>
import { onMounted, ref } from "vue";
import { useUserStore } from "../../store/user.js";
import 'sweetalert2/dist/sweetalert2.min.css';
import Swal from "sweetalert2/dist/sweetalert2.js";

const userStore = useUserStore();

let paymentLinks = {
  initial: "https://www.asaas.com/c/671830468020",    // Inicial
  intermediary: "https://www.asaas.com/c/748888919515",  // Intermediário
  unlimited:  "https://www.asaas.com/c/64qnk3w9mqacjzuv"     // Ilimitado
}

let licenseIsActive = ref(userStore.user.hasActiveSubscription);

onMounted(() => {
  document.addEventListener('keydown', function(event) {
    if (event.keyCode === 123) { // 123 é o código do botão F12
      event.preventDefault();
    }
  })
});

const openCheckout = (plan) => {

    Swal.fire({
      title: "Atenção!",
      text: "Lembre-se de usar o mesmo e-mail dessa conta para fazer a compra.",
      icon: "warning",
      input: 'checkbox',
      inputValue: false,
      inputPlaceholder:'Eu concordo com os <a href="https://fourlions.com.br/psicoapp/termos-de-uso.html" target="_blank">Termos e Condições de uso</a>',
      inputValidator: (result) => {
            return !result && 'Para prosseguir com a compra você precisa concordar com os Termos e Condições de uso.'
        },
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Ok",
      showCancelButton: true,
    }).then((result) => {
        if(result.isConfirmed){
            switch (plan) {
                case "initial":
                    window.open(paymentLinks.initial, "_self");
                    break;
                case "intermediary":
                    window.open(paymentLinks.intermediary, "_self");
                    break;
                case "unlimited":
                    window.open(paymentLinks.unlimited, "_self");
                    break;
                default:
                alert("Desculpe, ocorreu um erro ao tentar abrir o link para comprar a licença do aplicativo. Por favor, tente novamente mais tarde ou entre em contato com o suporte para obter ajuda.")
                    break;
            }
        }
    });
}
</script>
<template>
    <div id="background-modal" v-if="!licenseIsActive">
        <div id="title">
            <h1>Sua assinatura expirou. </h1>
            <h3>
                Por favor, renove-a para continuar utilizando nossos serviços.
            </h3>
        </div>
        <div id="container_cards">
            <main id="modal">
                <!-- <div class="card">
                    <div class="card pt-0 pb-0 mb-0">
                      <div id="card1" class="card-body d-flex flex-column justify-content-between align-items-center">
                          <div class="price d-flex flex-column justify-content-center align-items-center text-center">
                            <p style="font-weight: 800;">Plano Inicial</p>
                              <div class="d-flex flex-row align-items-center justify-content-center">
                                <span class="txts-price" style="margin-right: 10px;">R$</span>
                                <span id="price-value">97</span>
                                <span class="txts-price" style="font-size: 16px; margin-bottom: 30px;">,90</span>
                                <span class="txts-price" style="margin-left: 7px;">/ mês</span>
                              </div>
                              <span class="patient-limit">Até 10 pacientes</span>
                              <div class="w-100 text-start">
                              </div>                           
                            </div>
                          <div class="button-wrapper">
                            <button @click="openCheckout('initial')" class="btn-price" data-bs-toggle="modal" data-bs-target="#ModalCustumores">Assinar plano</button>
                          </div>
                      </div>
                    </div>
                </div> -->
                <!-- <div class="card">
                    <div class="card pt-0 pb-0 mb-0">
                      <div id="card2" class="card-body d-flex flex-column justify-content-between align-items-center">
                          <div class="price d-flex flex-column justify-content-center align-items-center text-center">
                            <p style="font-weight: 800;">Plano Intermediário</p>
                              <div class="d-flex flex-row align-items-center justify-content-center">
                                <span class="txts-price" style="margin-right: 10px;">R$</span>
                                <span id="price-value">147</span>
                                <span class="txts-price" style="font-size: 16px; margin-bottom: 30px;">,90</span>
                                <span class="txts-price" style="margin-left: 7px;">/ mês</span>
                              </div>
                              <span class="patient-limit">Até 30 pacientes</span>
                              <div style="margin-top: -5px;" class="px-5 w-100 text-start">
                                <bold style="font-weight: 600;"></bold>
                                <small style="font-weight: 600; margin-left: 5px; font-size: 15px; color: red;"></small>
                              </div>
                          </div>
                          <div class="button-wrapper">
                            <button @click="openCheckout('intermediary')" class="btn-price" data-bs-toggle="modal" data-bs-target="#ModalCustumores">Assinar plano</button>
                          </div>
                      </div>
                    </div>
                </div> -->
                <div class="card">
                    <div class="card pt-0 pb-0 mb-0">
                      <div id="card3" class="card-body d-flex flex-column justify-content-between align-items-center">
                          <div class="price d-flex flex-column justify-content-center align-items-center text-center">
                            <p style="font-weight: 800;">Plano Ilimitado</p>
                              <div class="d-flex flex-row align-items-center justify-content-center">
                                <span class="txts-price" style="margin-right: 10px;">R$</span>
                                <span id="price-value">89</span>
                                <span class="txts-price" style="font-size: 16px; margin-bottom: 30px;">,90</span>
                                <span class="txts-price" style="margin-left: 7px;">/ mês</span>
                              </div>
                              <span class="patient-limit">Pacientes ilimitados</span>
                              <div style="margin-top: -5px;" class="px-5 w-100 text-start">
                                <bold style="font-weight: 600;"></bold>
                                <small style="font-weight: 600; margin-left: 5px; font-size: 15px; color: red;"></small>
                              </div>
                          </div>
                          <div class="button-wrapper">
                            <button @click="openCheckout('unlimited')" class="btn-price" data-bs-toggle="modal" data-bs-target="#ModalCustumores">Assinar plano</button>
                          </div>
                          <div style="margin-top: 10px; text-align: center; font-size: x-small;">
                            CNPJ utilizado na página de pagamento - 49.466.945/0001-92
                            <br>
                            Razão social: T.Z ASSESSORIA E SERVICOS LTDA - 
                          </div>
                      </div>
                    </div>
                </div>
            </main>
        </div>
        <footer style="bottom: 0; background-color: white; width: 100%; display: flex; flex-direction: column; justify-content: center;">
            <p style="font-size: 11px; margin: 0; font-weight: 700; white-space:pre-line; width: 100%;text-align: center; padding-top: 2px;">Dúvidas sobre o pagamento? Entre em contato conosco!</p>
            <div style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center; padding: 10px; gap: 10px;">
                <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 4px;">
                    <a href="https://fourlions.com.br/">
                        <img src="../../assets/images/logo-fl.png" width="200px" alt="fourlions tecnologia">
                    </a>
                </div>
                <div style="display: flex; flex-direction: row; gap: 15px; justify-content: center; align-items: center;">
                    <div style="display: flex; gap: 4px;">
                        <img src="../../assets/icons/phone.svg" alt="telefone">
                        <a href="tel:+551635249416" style="font-weight: 500; color: #7da8ff; font-size: 14px;">+55(16) 3524-9416</a>
                    </div>
                    <div style="display: flex; gap: 4px;">
                        <img src="../../assets/icons/mail.svg" alt="email">
                        <a href="mailto:contato@fourlions.com.br" style="font-weight: 500; color: #7da8ff; font-size: 14px;">contato@fourlions.com.br</a>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<style lang="postcss" scoped>
#background-modal{
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgb(0, 0, 0, 0.3);
    z-index: 1000;
    width: 100%;
    height: 100%;
}
#modal{
    display: flex;
    padding: 0px 20px 20px 20px;
    flex-direction:row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    column-gap: 24px;
    height: 80vh;
}
.card{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    background-color: transparent!important;
    border: none;
    width: fit-content;
    height: fit-content;
    margin-top: 5px;
}
h3{
    font-size: 18px;
    color:#fff;
    font-weight: 600;
}

/* prices */

#price{
    width: 366px;
    margin-top: 40px;
}
#price h3{
    font-size: 60px;
    font-weight: 700;
}
#price-value{
    font-size: 50px;
    font-weight: 800;
} 
#price p{
    font-weight: 500;
}
#price .card{
    min-height: 700px;
    max-width: 370px;
    width: 80vw;
}
#price li{
    text-align: start;
    list-style-type: none;
    position:relative;
    margin-bottom:0.5em;
    color: rgb(38, 48, 56);
    font-weight: 600;
}
#price li:before {
    content: '☑';
    display: inline-block;
    position: absolute;
    left: -1.05em;
    color:#548dff;
  }
.card-body{
    height: 100%;
    display: flex;
    justify-items: center;
    align-items: start;
    border-radius: 15px;
}
#card1{
    background-image: linear-gradient(to bottom,  #7DA8FF, #fff9ec, #fff9ec);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000;
    max-width: 400px;
    width: 75vw;
    outline: 2px solid #7DA8FF;
}
#card2{
    background-image: linear-gradient(to bottom,  #fbb77f, #fff9ec, #fff9ec);
    color: #000;
    max-width: 400px;
    width: 75vw;
    outline: 2px solid #fbb77f;
}
#card3{
    background-image: linear-gradient(to bottom,  #7DA8FF, #fff9ec, #fff9ec);
    color: #000;
    max-width: 400px;
    width: 75vw;
    outline: 2px solid #7DA8FF;
}
.txts-price{
    font-size: 20px;
    font-weight: 700;
}
.btn-price{
    margin-top: 15px;
    width: 200px;
    height: 45px;
    border: none;
    border-radius: 100px;
    background-color: #7DA8FF;
    color: #fff;
    font-weight: 700;
    animation: example2 .3s;
}
.btn-price:hover{
    border: 3px solid #7DA8FF;
    background-color: #fff;
    color: #000000;
    animation: example .3s;
}
#price b, .frequency{
    font-size: 14px;
}
#title{
    color: #fff;
    font-size: 20px;
    background-color: #fff;
    width: 100%;
    top: 0;
    z-index: 2000;
    padding: 10px 8px 3px 30px;
}
#title h1{
    color: #548dff;
    font-size: 24px;
    font-weight: 900;
}
#title h3{
    font-size: 15px;
    color: #000;
    line-height: 20px;
}
.button-wrapper{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
#container_cards{
    overflow: auto;
    height: 100%;
    width: 100%;
    margin-bottom: 8px;
    margin-top: 8px;
}
.patient-limit{
    font-weight: 600;
}
</style>